import { Col as BootstrapCol, type ColProps } from 'react-bootstrap';

type Props = ColProps;

const Col = (props: Props) => {
  const xs = props.xs ? props.xs : 12;
  const sm = props.sm ? props.sm : 12;
  const md = props.md ? props.md : true;
  const lg = props.lg ? props.lg : true;
  const xl = props.xl ? props.xl : true;
  const newProps = { ...props, sm, md, lg, xl, xs };

  return <BootstrapCol {...newProps} />;
};

export { Col };
